import qs from 'qs'
import axios from 'axios'
import {APIDOC} from 'config/apiurl'

const defError = (
  code = 'EDF',
  message = 'Gagal saat mengambil data, silakan coba kembali!'
) => ({
  status: 0,
  message: `[${code}] ` + message,
})

export const mSubmitSetting = async args => {
  try {
    const {data} = await axios.post(
      APIDOC + '/pengaturan-pcare/update',
      qs.stringify(args)
    )

    if (data?.status == 1) return data
    return defError('EPSS-CE-3', data?.message)
  } catch (e) {
    return defError(
      'EPSS-CE-4',
      'Gagal saat menyimpan data, silakan coba kembali!'
    )
  }
}

export const qIndex = async args => {
  try {
    const {data} = await axios.post(
      APIDOC + '/pengaturan-pcare/get-data',
      qs.stringify(args)
    )

    if (data?.status == 1) return data
    return defError('EPSS-CE')
  } catch (e) {
    return defError('EPSS-CE-2')
  }
}
